
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.507.5c-.22 0-.286.192-.515.829a3.67 3.67 0 00-.234 1.119v2.647a.697.697 0 01-.141.44l-.731.445v-.468a.206.206 0 00-.201-.225h-.37a.168.168 0 00-.126.056.417.417 0 00-.075.286v.468c0 .101.017.202.056.295l-1.565.96v-.379a.206.206 0 00-.201-.225h-.37a.172.172 0 00-.127.056.416.416 0 00-.074.286v.469a.77.77 0 00.042.252L1.17 8.861a.321.321 0 00-.15.243l-.192.398a.092.092 0 000 .052v.131c0 .091.1.145.178.098l.229-.14 2.15-.904 2.37-.806.96-.056.047.468v1.972c.056.813.158 1.621.305 2.422-.267.183-1.302.88-1.466.983a.888.888 0 00-.258.656c0 .065.053.117.117.117h.033l1.766-.552.042.276a.118.118 0 00.061.084v.08c0 .065.052.117.117.117a.155.155 0 00.154-.117v-.08a.115.115 0 00.061-.084l.043-.276 1.77.552h.033a.117.117 0 00.117-.117.888.888 0 00-.258-.656c-.168-.103-1.203-.805-1.466-.983.147-.801.249-1.609.305-2.422V8.322l.027-.261.02-.184.96.056 2.379.811 2.155.908.215.131a.117.117 0 00.178-.098v-.131a.092.092 0 000-.052l-.192-.398a.321.321 0 00-.15-.243c-.093-.066-1.353-.834-1.705-1.05a.77.77 0 00.042-.252V7.09a.405.405 0 00-.074-.276.168.168 0 00-.127-.056h-.37a.204.204 0 00-.201.224v.403l-1.565-.96a.73.73 0 00.056-.295v-.468a.402.402 0 00-.075-.277.168.168 0 00-.126-.056h-.37a.205.205 0 00-.201.225v.426l-.726-.445a.692.692 0 01-.141-.44V2.448a3.67 3.67 0 00-.234-1.119C7.788.692 7.718.5 7.498.5h.009z"}})])
          )
        }
      }
    